import { Color } from "./Color";
import Matrix from "./Matrix";
import { Texture } from "./Texture";

// canvas 2D描画のラッパー
export class Graphics2D {
  private readonly context: CanvasRenderingContext2D;

  constructor(private readonly canvas: HTMLCanvasElement) {
    // 実解像度に一致していないので再設定
    canvas.width = canvas.clientWidth;
    canvas.height = canvas.clientHeight;

    const context2D = canvas.getContext("2d");
    if (context2D === null) {
      throw new Error("CanvasRenderingContext2D に未対応のブラウザです。");
    }
    this.context = context2D;
  }

  public get width() {
    return this.canvas.width;
  }

  public get height() {
    return this.canvas.height;
  }

  // canvasをすべて上書き
  public clear(color: Color) {
    const w = this.canvas.width;
    const h = this.canvas.height;
    if (color.equal(Color.Transparent)) {
      this.context.clearRect(0, 0, w, h);
    } else {
      this.context.fillStyle = color.code();
      this.context.fillRect(0, 0, w, h);
    }
  }

  // 矩形範囲を指定カラーで塗りつぶし
  public fillRect(x: number, y: number, w: number, h: number, color: Color) {
    this.context.fillStyle = color.code();
    this.context.fillRect(x, y, w, h);
  }

  // 矩形範囲を指定カラーで塗りつぶし
  public fillCard(m: Matrix, color: Color) {
    this.context.fillStyle = color.code();
    this.context.setTransform(m.m[0], m.m[1], m.m[4], m.m[5], m.m[12], m.m[13]);
    this.context.fillRect(-0.5, -0.5, 1, 1);
    this.context.resetTransform();
  }

  // テクスチャを描画
  public drawTexture(texture: Texture, x: number, y: number): void;
  public drawTexture(
    texture: Texture,
    x: number,
    y: number,
    width: number,
    height: number
  ): void;
  public drawTexture(): void {
    const texture: Texture = arguments[0];
    if (texture.isLoading) {
      return;
    }
    const x: number = arguments[1];
    const y: number = arguments[2];

    let width: number;
    let height: number;
    if (arguments.length === 3) {
      width = texture.img.width;
      height = texture.img.height;
    } else {
      width = arguments[3];
      height = arguments[4];
    }

    this.context.drawImage(texture.img, x, y, width, height);
  }
}
